export enum PaymentSystem {
  WebMoney,
  QIWI,
  Capitalist,
  USDT,
  CARD,
  USDC,
}
